import {
    openWallet,
    importWallet,
    extendNewPrivateKey,
    createCredentials,
    doCreateWallet,
    doCreateMultiWallet,
    doJoinMultiWallet,
    importMnemonic,
    publishTx,
    signTx,
    broadcastTx,
    removeTx
} from '@/wallet/bcw_api.js'
import { coldingAmount } from '@/store/nodeutl.js'
import { saveAccount, getLastAddress, setLastAddress } from '@/utils/appcache.js'
import store from '@/store'
const _ = require('lodash')

/**
 * 生成秘钥信息
 */
export function createNewPrivateKey() {
    return extendNewPrivateKey()
}

/**
 * 创建新账户
 */
export function createNewCredentials(ismulti) {
    const ireneKeys = extendNewPrivateKey()
    const credentials = createCredentials(ireneKeys, ismulti)
    credentials.mnemonic = ireneKeys.mnemonic
    credentials.mnemonicHasPassphrase = ireneKeys.mnemonicHasPassphrase
    return credentials
}

/**
 * 使用助记词生成账户
 */
export function importWithMnemonic(words, ismulti) {
    const ireneKeys = importMnemonic(words)
    const credentials = createCredentials(ireneKeys, ismulti)
    credentials.mnemonic = ireneKeys.mnemonic
    credentials.mnemonicHasPassphrase = ireneKeys.mnemonicHasPassphrase
    return credentials
}


/**
 * 获取私钥信息
 */
export function getPrivateKeyWithIndex(i) {
  const client = store.state.wallet.client
  const key = importMnemonic(client.credentials.mnemonic)
  const rootPath = 'm/44\'/57\'/0\''
  const index = 'm/0/' + i.toString()
  const pk = key.getPrivateKeyofWif('', rootPath, index, 'vcl', 'livenet')

  const privKey = key.getPrivateKey('', client.getRootPath(), index, 'vcl')
  const address = privKey.publicKey.toAddress('livenet').toString()
  return { address, pk }
}

/**
 * 创建一个默认的钱包账户
 * @param {Object} opts
 */
export function createDefaultWallet(name, ireneKeys) {
    return new Promise((resolve, reject) => {
        doCreateWallet(name, ireneKeys)
            .then(wallet => {
                return resolve(wallet)
            })
            .catch(err => {
                return reject(err)
            })
    })
}

/**
 * 创建一个多签钱包
 * m - 需签名数量
 * n - 总签名数量
 */
export function createMultiWallet(name, ireneKeys, m, n) {
    return new Promise((resolve, reject) => {
        if (n < m) {
            return reject('总签名数量不能小于交易签名数量')
        }
        if (n == 1) {
            return reject('总签名数量不能小于1')
        }
        doCreateMultiWallet(name, ireneKeys, m, n)
            .then(wallet => {
                return resolve(wallet)
            })
            .catch(err => {
                return reject(err)
            })
    })
}

/**
 * 加入到一个多签钱包
 */
export function joinMultiWallet(secret, name, ireneKeys) {
    return new Promise((resolve, reject) => {
        doJoinMultiWallet(secret, name, ireneKeys)
            .then(wallet => {
                return resolve(wallet)
            })
            .catch(err => {
                return reject(err)
            })
    })
}

/**
 * 通过助记词导入钱包
 */
export function importAccountWithMnemonic(ireneKeys) {
    return new Promise((resolve, reject) => {
        importWallet(ireneKeys)
            .then(wallet => {
                return resolve(wallet)
            })
            .catch(err => {
                return reject(err)
            })
    })
}

/**
 * 打开一个钱包客户端
 * @param {Object} credentials
 */
export function oepnWalletWithCredentials(credentials) {
    return openWallet(credentials)
}

/**
 * 检查外部系统地址
 */
export function startScan() {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.startScan(
            {
                includeCopayerBranches: false
            },
            err => {
                if (err) return reject(err)
                return resolve(true)
            }
        )
    })
}

/** 获取一个钱包地址
 * @param {Object} credentials
 * @param {Object} forceNew
 */
export function getAddress(credentials, forceNew) {
    return new Promise((resolve, reject) => {
        getLastAddress(credentials.keyId).then(ad => {
            if (!forceNew && ad) return resolve(ad)
            const client = oepnWalletWithCredentials(credentials)
            client.openWallet(orr => {
                if (orr) {
                    return reject('打开钱包失败:', orr)
                }
                if (!client.isComplete()) return reject('账户初始化中')

                client.createAddress({ coin: 'vcl', network: 'livenet' }, (err, addr) => {
                    if (err) {
                        if (
                            (err.message && err.message == 'MAIN_ADDRESS_GAP_REACHED') ||
            err.message ==
              'Maximum number of consecutive addresses without activity reached'
                        ) {
                            client.getMainAddresses(
                                {
                                    reverse: true,
                                    limit: 1
                                },
                                (err, addr) => {
                                    if (err) reject(err)
                                    setLastAddress(credentials.keyId, addr[0].address)
                                    return resolve(addr[0].address)
                                }
                            )
                        } else {
                            return reject(err)
                        }
                    } else {
                        setLastAddress(credentials.keyId, addr.address)
                        return resolve(addr.address)
                    }
                })
            })
        }).catch(e => {
            return reject(e)
        })
    })
}

/**
 * 校验地址是否为当前钱包的地址
 */
export function isValidAddress(address) {
    const currentAccount = store.state.wallet.account
    const ireneKeys = importMnemonic(currentAccount.mnemonic)
    let isvalid = false
    for (let i = 0; i <= 3; i++) {
        isvalid = ireneKeys.isValidAddress('', currentAccount.rootPath, 'vcl', address, i * 100, i * 100 + 100)
        if (isvalid) break
    }
    return isvalid
}

/**
 * 更新一个钱包的状态到cache
 */
export function updateAccountStatus(currentAccount) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getStatus({}, (err, ret) => {
            if (err) {
                return reject(err)
            }
            currentAccount.cacheStatus = ret
            saveAccount(currentAccount)
            return resolve(ret)
        })
    })
}

/** 从服务器查询交易记录
 * @param {Object} wallet
 * @param {Object} skip
 * @param {Object} endingTxid
 * @param {Object} limit
 */
export function getTxsFromServer(page, limit) {
    return new Promise((resolve, reject) => {
        const currentAccount = store.state.wallet.account
        if (!currentAccount || currentAccount == 'null') {
            return reject('未找到账户信息')
        }
        if (
            currentAccount.cacheStatus &&
      currentAccount.cacheStatus.wallet &&
      currentAccount.cacheStatus.wallet.n > 1 &&
      currentAccount.cacheStatus.wallet.beRegistered == false
        ) {
            console.log('待注册的多签账户无法更新交易记录')
            return reject('账户状态异常')
        }
        const wallet = store.state.wallet.client
        let res = []
        const skip = (page - 1) * limit
        const result = {
            res,
            shouldContinue: res.length >= limit
        }
        wallet.getTxHistory(
            {
                skip: skip,
                limit: limit,
                includeExtendedInfo: true
            },
            (err, txsFromServer) => {
                if (err) return reject(err)
                if (_.isEmpty(txsFromServer)) return resolve(result)
                res = txsFromServer
                result.res = res
                result.shouldContinue = res.length >= limit
                return resolve(result)
            }
        )
    })
}

/**
 * 查询一个交易信息
 */
export function getTxInfo(txid) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getCoinsForTx({ txid: txid }, res => {
            if (res) {
                return resolve(res)
            } else {
                return reject('未找到交易')
            }
        })
    })
}

/**
 * 创建一笔交易
 * @param {Object} txp
 */
export function createTx(txp) {
    return new Promise((resolve, reject) => {
        if (_.isEmpty(txp)) return reject('参数丢失')

        const client = store.state.wallet.client
        coldingAmount().then(v => {
            txp.excludeMasternode = v > 0 // 是否花费质押链分
            try {
                client.createTxProposal(txp, (err, createdTxp) => {
                    if (err) return reject(err)
                    else {
                        return resolve(createdTxp)
                    }
                })
            } catch (error) {
                return reject(error)
            }
        })
    })
}

/**
 * 发布+签名 用于兑现
 * @param {*} txp
 * @returns
 */
export function publishThenSign(txp) {
  return new Promise((resolve, reject) => {
    const client = store.state.wallet.client
    if (txp.status == 'pending' || txp.status == 'accepted') {
        signTx(client, txp)
            .then(signedTxp => {
              return resolve(signedTxp)
            })
            .catch(err => {
                const msg =
        err && err.message
            ? err.message
            : 'The payment was created but could not be completed. Please try again from home screen'
                return reject(msg)
            })
    } else {
        publishTx(client, txp)
            .then(publishedTxp => {
                signTx(client, publishedTxp)
                    .then(signedTxp => {
                      return resolve(signedTxp)
                    })
                    .catch(err => {
                        const msg =
            err && err.message
                ? err.message
                : 'The payment was created but could not be completed. Please try again from home screen'
                        return reject(msg)
                    })
            })
            .catch(err => {
                return reject(err)
            })
    }
  })
}

/**
 * 发布+签名 （适用于多签交易）
 */
export function publishAndSign(txp) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        if (txp.status == 'pending' || txp.status == 'accepted') {
            signTx(client, txp)
                .then(signedTxp => {
                    if (signedTxp.status == 'accepted') {
                        broadcastTx(client, signedTxp)
                            .then(broadcastedTxp => {
                                return resolve(broadcastedTxp)
                            })
                            .catch(err => {
                                return reject(err)
                            })
                    } else {
                        return resolve(signedTxp)
                    }
                })
                .catch(err => {
                    const msg =
            err && err.message
                ? err.message
                : 'The payment was created but could not be completed. Please try again from home screen'
                    return reject(msg)
                })
        } else {
            publishTx(client, txp)
                .then(publishedTxp => {
                    signTx(client, publishedTxp)
                        .then(signedTxp => {
                            if (signedTxp.status == 'accepted') {
                                broadcastTx(client, signedTxp)
                                    .then(broadcastedTxp => {
                                        return resolve(broadcastedTxp)
                                    })
                                    .catch(err => {
                                        return reject(err)
                                    })
                            } else {
                                return resolve(signedTxp)
                            }
                        })
                        .catch(err => {
                            const msg =
                err && err.message
                    ? err.message
                    : 'The payment was created but could not be completed. Please try again from home screen'
                            return reject(msg)
                        })
                })
                .catch(err => {
                    return reject(err)
                })
        }
    })
}

/** 发布交易+签名+广播
 * @param {Object} txp
 */
export function publishAndSignAndBroad(txp) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        // Already published?
        if (txp.status == 'pending' || txp.status == 'accepted') {
            signAndBroadcast(client, txp)
                .then(broadcastedTxp => {
                    return resolve(broadcastedTxp)
                })
                .catch(err => {
                    return reject(err)
                })
        } else {
            publishTx(client, txp)
                .then(publishedTxp => {
                    signAndBroadcast(client, publishedTxp)
                        .then(broadcastedTxp => {
                            return resolve(broadcastedTxp)
                        })
                        .catch(err => {
                            return reject(err)
                        })
                })
                .catch(err => {
                    return reject(err)
                })
        }
    })
}

/**
 * 交易签名+广播
 * @param {Object} wallet
 * @param {Object} publishedTxp
 */
export function signAndBroadcast(wallet, publishedTxp) {
    return new Promise((resolve, reject) => {
        signTx(wallet, publishedTxp)
            .then(signedTxp => {
                if (signedTxp.status == 'accepted') {
                    broadcastTx(wallet, signedTxp)
                        .then(broadcastedTxp => {
                            return resolve(broadcastedTxp)
                        })
                        .catch(err => {
                            return reject(err)
                        })
                } else {
                    return resolve(signedTxp)
                }
            })
            .catch(err => {
                const msg =
          err && err.message
              ? err.message
              : 'The payment was created but could not be completed. Please try again from home screen'
                return reject(msg)
            })
    })
}

/**
 * 删除交易
 */
export function removeTxProposal(tx) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        removeTx(client, tx)
            .then(res => {
                return resolve(res)
            })
            .catch(err => {
                return reject(err)
            })
    })
}

/**
 * 获取指定排除地址的UTXOS
 */
export function addressUtxos(R_ADDRESS) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getUtxos({}, (err, utxos) => {
            if (err) {
                return reject(err)
            } else {
                if (R_ADDRESS) {
                    var ret = []
                    if (utxos != null && utxos.length > 0) {
                        ret = utxos.filter(item => item.address != R_ADDRESS)
                    }
                    return resolve(ret)
                } else {
                    return resolve(utxos)
                }
            }
        })
    })
}

// /////////////////////////// 主节点
/**
 * 获取私钥信息
 */
export function getPrivateKey(path) {
    const client = store.state.wallet.client
    const ireneKeys = importMnemonic(client.credentials.mnemonic)
    const privKey = ireneKeys.getPrivateKey('', client.getRootPath(), path)
    return privKey
}

/**
 * 加载可用抵押的交易
 */
export function loadNodeCollateral() {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getMasternodeCollateral({}, (err, utxos) => {
            if (err) {
                return reject(err)
            }

            return resolve(utxos)
        })
    })
}

/**
 * 获取交易哈希
 */
export function getMasternodePing(txid, vout) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getMasternodePing({ txid: txid, vout: vout }, (err, pingRet) => {
            if (err) {
                return reject(err)
            }
            return resolve(pingRet)
        })
    })
}

/**
 * 主节点质押签名
 */
export function signMasternode(pingRet) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.signMasternode(pingRet, (err, signRet) => {
            if (err) {
                return reject(err)
            }
            return resolve(signRet)
        })
    })
}

/**
 * 主节点质押广播
 */
export function broadcastMasternode(signRet, privKey) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.broadcastMasternode(
            { rawTx: signRet, masternodeKey: privKey },
            (err, result) => {
                if (err) {
                    return reject(err)
                }
                return resolve(result)
            }
        )
    })
}

/**
 * 主节点状态查询
 */
export function getMasternodeStatus(address) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getMasternodeStatus({ address: address }, (err, result) => {
            if (err) {
                return reject(err)
            }
            return resolve(result)
        })
    })
}

/**
 * 主节点状态查询
 */
export function getWalletNodes() {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.getMasternodes({}, (err, result) => {
            if (err) {
                return reject(err)
            }
            return resolve(result)
        })
    })
}

/**
 * 删除主节点
 */
export function deleteMasterNode(txid) {
    return new Promise((resolve, reject) => {
        const client = store.state.wallet.client
        client.removeMasternodes({ txid }, (err, result) => {
            if (err) {
                return reject(err)
            }
            return resolve(result)
        })
    })
}



// WEBPACK FOOTER //
// ./src/wallet/walletUtil.js